import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useState } from 'react';
import classNames from 'classnames/bind';
import { LikeFilledIcon, LikeOutlineIcon, Tooltip } from '@beef/ui-kit';
import { COLORS } from "../../../../constants/common";
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
var SelectedFavorite = function SelectedFavorite() {
  return /*#__PURE__*/React.createElement(LikeFilledIcon, {
    fill: COLORS.BLACK,
    size: "s"
  });
};
export var Favorite = function Favorite(_ref) {
  var _ref$isVisible = _ref.isVisible,
    isVisible = _ref$isVisible === void 0 ? false : _ref$isVisible,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    _ref$tooltip = _ref.tooltip,
    tooltip = _ref$tooltip === void 0 ? '' : _ref$tooltip,
    deviceId = _ref.deviceId,
    setIsFavoriteSelected = _ref.setIsSelected;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isInView = _useState2[0],
    setIsInView = _useState2[1];
  var iconFill = isInView ? COLORS.RED : COLORS.GRAY_INACTIVE;
  var setIsSelected = useCallback(function (id) {
    return function () {
      if (setIsFavoriteSelected) {
        setIsFavoriteSelected(id);
      }
    };
  }, [setIsFavoriteSelected]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper', {
      'wrapper--visible': isVisible || isSelected
    }),
    onClick: setIsSelected(deviceId),
    onMouseEnter: function onMouseEnter() {
      return setIsInView(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsInView(false);
    },
    role: "button",
    tabIndex: 0
  }, isSelected ? /*#__PURE__*/React.createElement(SelectedFavorite, null) : /*#__PURE__*/React.createElement(Tooltip, {
    message: tooltip,
    position: "bottom"
  }, /*#__PURE__*/React.createElement(LikeOutlineIcon, {
    fill: iconFill,
    size: "s"
  })));
};